import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {rootRoutes, screenManagerProviders} from './pages/page-content.routing';
import {SectionsModule} from './components/sections/sections.module';

@NgModule({
    imports: [RouterModule.forRoot(rootRoutes), SectionsModule.forRoot(rootRoutes)],
    providers: screenManagerProviders,
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts